import * as React from 'react'
import { IconButton } from '@material-ui/core';

function Controls({ isPlaying, onPlay, onPause, onNext, onPrev, isHidden }): React.ReactElement {
  return (
    <div className={`controls ${isHidden ? 'hidden' : 'visible' }`}>
      <IconButton
        aria-label="Previous Slide"
        onClick={onPrev}
        children={<span className="fa fa-backward" aria-hidden="true" />}
      />
      {isPlaying ? (
        <IconButton
          aria-label="Pause"
          onClick={onPause}
          children={<span className="fa fa-pause" aria-hidden="true" />}
        />
      ) : (
        <IconButton
          aria-label="Play"
          onClick={onPlay}
          children={<span className="fa fa-play" aria-hidden="true" />}
        />
      )}
      <IconButton
        aria-label="Next Slide"
        onClick={onNext}
        children={<span className="fa fa-forward" aria-hidden="true" />}
      />
    </div>
  );
}

export default Controls
